import { render, staticRenderFns } from "./VFatherPatient.vue?vue&type=template&id=f4af892e"
import script from "./VFatherPatient.vue?vue&type=script&lang=js"
export * from "./VFatherPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports